import React, { useState, useEffect } from 'react'
import { Form, Button, Container, Row, Col } from 'react-bootstrap'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { useLoginMutation } from '../slices/usersApiSlice'
import { setCredentials } from '../slices/authSlice'
import "../assets/styles/index.css"
import { parseUserInfo } from "../utils/parseUtil"
import logo from '../assets/logo/legal-logo.jpg'
import complianceImage from '../assets/images/legal-compliance.jpg'

const LoginScreen = () => {
    const [userId, setUserId] = useState('')
    // const [empCode, setEmpCode] = useState('')
    const [password, setPassword] = useState('')

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [login, { isLoading }] = useLoginMutation()

    const { userInfo } = useSelector((state) => state.auth)

    const { search } = useLocation()
    const sp = new URLSearchParams(search)
    const redirect = sp.get('redirect') || '/'

    useEffect(() => {
        if (userInfo) {
            const userType = userInfo[1]?.InfoField2
            if (userType === "3") {
                navigate('/admin-dashboard')
            } else {
                navigate(redirect)
            }
        }
    }, [userInfo, redirect, navigate])

    const submitHandler = async (e) => {
        e.preventDefault()
        const formData = new FormData()
        formData.append('ReqUserID', userId)
        formData.append('ReqPassWord', password)
        formData.append('description', 'GetStaffDetails')
        formData.append('title', 'GetStaffInfoJason')
        formData.append('ReqType', 'Login')

        try {
            const res = await login(formData)

            const parsedUserInfo = parseUserInfo(res)

            if (parsedUserInfo) {
                const infoField1 = parsedUserInfo[0]?.InfoField1
                const errorCode = parsedUserInfo[0]?.ErrorCode;
                if ((infoField1 && parseInt(infoField1) < 1) || (errorCode && parseInt(errorCode) < 1)) {
                    toast.error(parsedUserInfo[0]?.InfoField || parsedUserInfo[0]?.ErrorMessage || 'Invalid User or Password')
                } else {
                    dispatch(setCredentials(parsedUserInfo))
                    const userType = parsedUserInfo[1]?.InfoField2
                    if (userType === "3") {
                        navigate('/admin-dashboard')
                    } else {
                        navigate(redirect)
                    }
                }
            } else {
                toast.error('Failed to parse user info')
            }
        } catch (err) {
            console.error('Login Error:', err)
            toast.error(err?.data?.message || err.error)
        }
    }

    return (
        <div className="modern-login-wrapper">
            <Container fluid className="login-split-container">
                <Row className="g-0 h-100 mobile-row-height">
                    {/* Left Side - Login Form */}
                    <Col lg={6} md={12} className="login-left-section">
                        <div className="login-form-wrapper">
                            {/* Logo */}
                            <div className="text-center mb-sm-4 mb-2">
                                <img 
                                    src={logo} 
                                    alt="Legal Infosolutions" 
                                    className="login-logo" 
                                    loading="eager"
                                />
                            </div>

                            {/* Welcome Text */}
                            <div className="text-center mb-sm-4 mb-2">
                                <h3 className="welcome-text">Login</h3>
                            </div>

                            {/* Login Form */}
                            <div className="login-form-box">
                                
                                <Form onSubmit={submitHandler}>
                                    <Form.Group className="mb-sm-3 mb-2">
                                        <Form.Label className="login-label">User ID</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={userId}
                                            onChange={(e) => setUserId(e.target.value)}
                                            required
                                            className="login-input"
                                            placeholder="Enter your user ID"
                                        />
                                    </Form.Group>
                                    
                                    <Form.Group className="mb-sm-4 mb-3">
                                        <Form.Label className="login-label">Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                            className="login-input"
                                            placeholder="Enter your password"
                                        />
                                    </Form.Group>

                                    <Button 
                                        type="submit" 
                                        className="login-submit-btn mb-sm-3 mb-2"
                                        disabled={isLoading}
                                        size="sm"
                                    >
                                        {isLoading ? 'Logging in...' : 'Login'}
                                    </Button>
                                </Form>

                                <div className="login-links">
                                    <p className="login-link-text">
                                        Create New Account? <Link to="/signup" className="login-link">Signup</Link>
                                    </p>
                                    <p className="login-link-text">
                                        Forgot Password? <Link to="/forgot" className="login-link">Forgot</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* Right Side - Welcome Section */}
                    <Col lg={6} className="login-right-section d-none d-lg-flex">
                        <div className="welcome-panel">
                            <h2 className="welcome-title">Welcome to Company Data Management</h2>
                            <div className="welcome-image-wrapper">
                                <img 
                                    src={complianceImage} 
                                    alt="Company Data Management" 
                                    className="welcome-illustration" 
                                    loading="eager"
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                
                {/* Mobile Illustration (only visible on small screens) */}
                <div className="d-lg-none text-center mobile-illustration-container">
                    <div className="mobile-welcome-title">
                        <h3>Legal Infosolutions</h3>
                        <p className="mb-1">Payroll Management System</p>
                    </div>
                    <div className="mobile-illustration-wrapper">
                        <img 
                            src={complianceImage} 
                            alt="Payroll Management" 
                            className="mobile-illustration" 
                            loading="eager"
                        />
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default LoginScreen
